export default __webpack_public_path__ + "static/Resume-18e156338f8925786cfcc5e5170fc0f2.pdf";